import React, { useState } from 'react';
import { Form, InputGroup, } from 'react-bootstrap';

const Amount = ({ label, name, value, onChange, disabled, ...props }) => {
    const [inputValue, setInputValue] = useState(value);
    const handleInputChange = (e) => {
        const { value } = e.target;
        if (isValidInput(value)) {
            setInputValue(value);
            if (onChange) {
                onChange(value);
            }
        }
    };

    const isValidInput = (input) => {
        const decimalPattern = /^\d+(\.\d{0,2})?$/;
        return decimalPattern.test(input) || input === '';
    };
    return (
        <Form.Group {...props}>
            <Form.Label>{label}</Form.Label>
            <InputGroup className="mb-3">
                <InputGroup.Text>$</InputGroup.Text>
                <Form.Control
                    type="number"
                    name={name}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    placeholder="0.00"
                    aria-label={label} />
                <Form.Control.Feedback type="invalid">
                    Please enter an Amount.
                </Form.Control.Feedback>
            </InputGroup>
        </Form.Group>
    );
};

// Default handler for onChange if not provided by parent component
Amount.defaultProps = {
    onChange: (value) => { },
};

export default Amount;